import { render, staticRenderFns } from "./CustomZplLabel.vue?vue&type=template&id=45af0b88"
import script from "./CustomZplLabel.vue?vue&type=script&lang=js"
export * from "./CustomZplLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports